import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyList = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 381.156,
	height: 272.291,
	viewBox: "0 0 381.156 272.291",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_15127",
			"data-name": "Rectangle 15127",
			width: 381.156,
			height: 272.291,
			fill: "none"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path-2",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Path_25531",
			"data-name": "Path 25531",
			d: "M953.557,787.113a2.272,2.272,0,0,0-2.156,1.855,2.221,2.221,0,0,0,1.46,3.075l19.551,6.13a2.735,2.735,0,1,0,1.648-5.215l-.048-.015-19.672-5.712a2.8,2.8,0,0,0-.783-.119Z",
			transform: "translate(-951.242 -787.113)",
			fill: "none"
		})
	})] }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_9983",
		"data-name": "Group 9983",
		transform: "translate(-303 -425.709)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Group_9982",
			"data-name": "Group 9982",
			transform: "translate(303 425.708)",
			children: [
				/* @__PURE__ */ _jsx("g", {
					id: "Group_9977",
					"data-name": "Group 9977",
					transform: "translate(0 0.001)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group_9976",
						"data-name": "Group 9976",
						transform: "translate(0 0)",
						children: [
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25507",
								"data-name": "Path 25507",
								d: "M231.5,83.633c-17.683,5.932-34.49,18.632-47.73,30.474-27.57,24.66-31.685,29.843-65.7,50.546-19.823,12.066-35.451,22.269-43.152,35.918-21.63,38.336,4.134,79.743,58.121,79.743H352.509s25.816.526,44.654-19.965C461.013,190.9,355.112,42.164,231.5,83.634",
								transform: "translate(-49.113 -55.815)",
								fill: "#eff7fc",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25508",
								"data-name": "Path 25508",
								d: "M934.34,382.4c-6.378,7.421-15.813,14.089-25.876,14.195-19.275.191-22.349-18.5-22.349-18.5s-4.084,11.248-19.406,10.65-24.8-19.734-22.258-29.686c2.62-10.239,6.151-8.227,12.886-5.962s16.841,14.751,22.182,11.181-2.038-6.745-14.08-10.713-19.209-12.021-15.793-22.629,12.8-16.917,14.308-7.073,10.036,24.1,18.423,24.677,6.6-7.483-2.894-9.481-11.917-10.82-13.92-20.232,2.476-15.9,10.925-18.935,2.99,5.118,7.224,21.644,10.276,8.585,11.065,3.93-8.022-8.383-9.2-19.1S888.53,295.245,896,292.169s6.749-2.046,3.727,8.387-2.373,15.631-.066,20.823,7.3.825,5.61-5.122-.856-17.548,5.148-27.15a25.712,25.712,0,0,1,3.348-4.284c5.411-5.536,11.2-6.008,11.2-6.008-1.618,3.355,10.092,8.187,8.009,23.94a23.881,23.881,0,0,1-5.424,11.713c-6.456,8.088-15.476,12.585-9.665,14.588,3.84,1.32,8.909-3.3,13.205-8.572a107.264,107.264,0,0,0,8.737-12.782s3.5,5.979,3.279,10.863c-.135,2.933-5.16,8.313-10.606,12.706a45.93,45.93,0,0,1-10.025,6.5c-6.673,2.729-14.639,7.937-.489,6.428a20.754,20.754,0,0,0,8.738-3.106c8.526-5.266,13.127-15.059,13.754-14.058.816,1.306-1.732,16.542-4.346,22.488a11.433,11.433,0,0,1-6.965,6.531c-3.034,1.059-6.995,1.234-12.086.372-10.732-1.809-18.9,8.291-4.1,10.67a25.214,25.214,0,0,0,12.319-1.169c7.142-2.411,11.372-6.439,12.988-1.345,1.145,3.606-2.129,11.02-7.95,17.812",
								transform: "translate(-616.179 -203.546)",
								fill: "#d8e7ff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25509",
								"data-name": "Path 25509",
								d: "M282.441,321.616a138.708,138.708,0,0,1,4.851,20.178,94.67,94.67,0,0,0-13.8,5.423,50.44,50.44,0,0,1,14.431-1.057c1.858,14.119,4.361,32.884,1.215,46.23-9.225-3.221-21.35-12.251-30.125-17.836q4.979-4.123,10.2-7.858a109.975,109.975,0,0,0-14.882,4.74,152.53,152.53,0,0,1-24.241-20.777,158.5,158.5,0,0,1,18.132-11,82.825,82.825,0,0,0-23.826,4.633,141.955,141.955,0,0,1-8.76-11.446c-.452-.658-.893-1.323-1.338-2a157.58,157.58,0,0,1-9.16-15.575l3.811-1.845q9.9-4.793,19.829-9.607c-8.734-.548-16.61,2.249-25.3,3.429-.7.093-1.411.2-2.109.307l0-.011a183.324,183.324,0,0,1-10.462-38.994c1.57-.469,3.17-.857,4.784-1.174,1.617-.344,3.275-.612,4.908-.806q-2.709-1.027-5.486-1.925c-1.647-.536-3.325-1.05-5.008-1.508-.941-6.8-1.746-14.2-2.5-22.4,10,2.842,19.2,5.672,27.652,8.87-.13,1.664-.222,3.327-.287,4.992q-.2,4.457-.081,8.909a63.012,63.012,0,0,1,3.791-6.374c1.116-1.618,2.288-3.192,3.542-4.718a109.135,109.135,0,0,1,24.185,13.858c-1.085,1.981-2.138,3.975-3.223,5.956-2.762,5.113-5.532,10.2-8.29,15.326q5.036-5.791,10.556-11.116,3.037-2.934,6.228-5.731a90.76,90.76,0,0,1,15.294,18.061,128.443,128.443,0,0,1,7.155,12.483q-2.26,2.47-4.531,4.944-5.41,5.93-10.818,11.834c5.372-2.44,10.748-4.907,16.121-7.347,1-.448,1.977-.9,2.962-1.348q2.564,6,4.573,12.281",
								transform: "translate(-136.964 -175.746)",
								fill: "#d8e7ff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25510",
								"data-name": "Path 25510",
								d: "M210.449,276.86l.282.346-.277.005q0-.176,0-.351m40.566,55.021.057.085-.079-.031Zm-52.383-69.167c.937,1.134,10.4,12.408,11.331,13.547a41.1,41.1,0,0,0-14.74-1.137l.156,1.2a39.813,39.813,0,0,1,15.506,1.455l.414.124q4.175,5.146,8.251,10.369a50.4,50.4,0,0,0-20.887,3.1q-.424.158-.846.324.116.608.234,1.21.515-.2,1.035-.4a49.138,49.138,0,0,1,21.47-2.95q1.463,1.883,2.912,3.776a70.32,70.32,0,0,0-21.134,4.456q-1.506.561-2.99,1.184.139.6.281,1.2,1.553-.656,3.132-1.244a68.785,68.785,0,0,1,21.612-4.415q3.038,3.981,6.019,8a131.271,131.271,0,0,0-27.308,9.884q.192.582.389,1.158a130.1,130.1,0,0,1,27.7-9.983q7,9.483,13.679,19.192a107.364,107.364,0,0,0-19.927,5.3,104.737,104.737,0,0,0-12.578,5.649q.287.531.581,1.062a103.442,103.442,0,0,1,12.418-5.576,106.165,106.165,0,0,1,20.266-5.328q2.626,3.831,5.2,7.7a79.039,79.039,0,0,0-34.386,9.2q.316.515.638,1.032a77.815,77.815,0,0,1,34.507-9.045h.031q4.9,7.379,9.608,14.875a119.346,119.346,0,0,0-27.561,6.676q-3.055,1.137-6.045,2.441.394.49.793.976,2.808-1.214,5.674-2.281a118.142,118.142,0,0,1,27.851-6.675q2.277,3.638,4.508,7.3-4.214,1.112-8.3,2.636a89.116,89.116,0,0,0-19.6,10.221q.435.436.874.868a87.843,87.843,0,0,1,27.687-12.645q2.289,3.771,4.53,7.571a66.875,66.875,0,0,0-27.687,9.36q.468.426.941.847a65.789,65.789,0,0,1,10.907-5.248,65.116,65.116,0,0,1,16.517-3.809q3.119,5.307,6.145,10.667a53.968,53.968,0,0,0-24.395,5.962q.536.409,1.076.813a52.864,52.864,0,0,1,5.181-2.251,52.285,52.285,0,0,1,18.823-3.309q3.6,6.4,7.06,12.865a32.232,32.232,0,0,0-15.048,3.566l1.157.775q1.347-.656,2.755-1.181a30.8,30.8,0,0,1,11.792-1.933c7.863,14.754-.728,4.166,6.08,19.431h1.325c-6.88-15.457,1.626-5.056-6.334-19.991a25.807,25.807,0,0,1,7.933-8.288q-.047-.689-.1-1.377a27.123,27.123,0,0,0-8.5,8.426q-3.471-6.482-7.073-12.892a53.124,53.124,0,0,1,14.05-9.942l-.162-1.266a54.35,54.35,0,0,0-14.5,10.115q-3.095-5.477-6.28-10.9a47.844,47.844,0,0,1,18.054-15.94q-.135-.608-.276-1.215a49.082,49.082,0,0,0-18.457,16q-2.183-3.7-4.41-7.37a80.755,80.755,0,0,1,21-15.8q-.172-.594-.348-1.185a82,82,0,0,0-21.3,15.917q-2.264-3.716-4.572-7.4a68.141,68.141,0,0,1,22.87-17.48q-.212-.57-.429-1.137a69.369,69.369,0,0,0-23.114,17.54q-4.861-7.737-9.92-15.351a80.017,80.017,0,0,1,19.669-28.407q-.341-.513-.684-1.017a81.3,81.3,0,0,0-19.795,28.21q-2.487-3.727-5.021-7.424a101.193,101.193,0,0,1,19.082-28.378q-.392-.468-.789-.928a102.465,102.465,0,0,0-19.1,28.14q-6.583-9.56-13.475-18.906a79.075,79.075,0,0,1,15.19-24.723q-.5-.344-1.016-.682a80.31,80.31,0,0,0-15.025,24.251q-3.033-4.094-6.124-8.145a53.006,53.006,0,0,1,11.824-21.6q-.553-.289-1.111-.574a54.255,54.255,0,0,0-11.634,20.965q-1.323-1.726-2.656-3.445a64.8,64.8,0,0,1,10.032-19.591q-.561-.26-1.126-.516a66.041,66.041,0,0,0-9.808,18.946q-4.517-5.794-9.156-11.5a52.452,52.452,0,0,1,1.9-14.112l-1.149-.388a53.731,53.731,0,0,0-1.944,13.03c-.786-.961-10.107-12.058-10.9-13.014a.605.605,0,0,0-.952.748l.019.023",
								transform: "translate(-142.519 -191.059)",
								fill: "#b4d2ff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25511",
								"data-name": "Path 25511",
								d: "M193.875,589.617c-4.028-4.983-10.954-7.656-16.8-6.376a33.206,33.206,0,0,0,17.2,7.158q1.133.652,2.26,1.312c-5.49-1.643-11.527-.005-14.8,4.094a21.613,21.613,0,0,0,15.37-3.759q1.945,1.144,3.876,2.316c-5.581-1.018-11.33,1.186-14.238,5.567a24.264,24.264,0,0,0,15.026-5.086q1.893,1.156,3.772,2.338a9.866,9.866,0,0,0-7.149,1.072,18.681,18.681,0,0,0-5.8,5.745,21.849,21.849,0,0,0,13.913-6.209q2.062,1.307,4.105,2.644a14.241,14.241,0,0,0-12.623,7.6c5.387-.54,10.348-2.987,12.861-7.44q2.445,1.6,4.863,3.248a16.138,16.138,0,0,0-14.691,8.656,30.538,30.538,0,0,0,15.218-8.3q2.009,1.373,4,2.776a12.892,12.892,0,0,0-7.9,3.185,12.389,12.389,0,0,0-3.993,8.2,38.042,38.042,0,0,0,12.413-11.021q1.465,1.036,2.919,2.089a15.982,15.982,0,0,0-10.11,11.443,21.261,21.261,0,0,0,10.282-11.318q2.457,1.782,4.882,3.605a14.31,14.31,0,0,0-9.535,10.666c-.108.521.043,1.328.594,1.321a.792.792,0,0,0,.478-.23,26.709,26.709,0,0,0,8.623-11.635q3.836,2.888,7.589,5.888a13.884,13.884,0,0,0-12.485,7.04c5.175-.461,10.07-2.285,13.116-6.533q2.247,1.8,4.465,3.646a10.639,10.639,0,0,0-11.1,7.831c4.667-.974,8.87-3.361,11.341-7.631q3.514,2.927,6.949,5.947l1.29-.17q-2.575-2.27-5.181-4.5c2.473-1.409,3.647-4.508,3.42-7.7a8.7,8.7,0,0,0-4.16,7.065q-1.783-1.519-3.582-3.016a13.008,13.008,0,0,0,2.839-11.11A11.31,11.31,0,0,0,239.9,620.61q-2.43-2.012-4.889-3.979a13.574,13.574,0,0,0,5.182-10.316,9.924,9.924,0,0,0-5.984,9.676q-1.393-1.107-2.8-2.2a41.2,41.2,0,0,0,4.769-13.084,15.83,15.83,0,0,0-5.433,5.678,8.3,8.3,0,0,0-.338,6.631q-2.333-1.8-4.7-3.544a16.206,16.206,0,0,0,3.694-13.26,12.164,12.164,0,0,0-4.628,12.573q-2.047-1.5-4.117-2.958a20.619,20.619,0,0,0,1.655-14.719,11.155,11.155,0,0,0-3.779,7.058,13.161,13.161,0,0,0,1.058,6.914q-2.076-1.446-4.178-2.847a18,18,0,0,0,.864-14.889c-3.409,3.5-4.153,9.293-1.976,14.153q-1.968-1.3-3.96-2.549a18.39,18.39,0,0,0-2.12-15.978c-2.315,4.513-1.9,10.466.938,15.239q-2.1-1.3-4.222-2.551a17.631,17.631,0,0,0-5.823-15.206,22.117,22.117,0,0,0,4.869,14.647q-2.481-1.441-5-2.809a25.233,25.233,0,0,0-8.729-15.3,21.333,21.333,0,0,0,7.223,14.488q-1.794-.952-3.607-1.865",
								transform: "translate(-129.273 -421.228)",
								fill: "#2cd5c4"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25512",
								"data-name": "Path 25512",
								d: "M394.618,323.567h165.19a5.636,5.636,0,0,1,5.619,5.619V434.068a5.636,5.636,0,0,1-5.619,5.619H394.618a5.636,5.636,0,0,1-5.62-5.619V329.186a5.636,5.636,0,0,1,5.619-5.619",
								transform: "translate(-283.983 -236.216)",
								fill: "#032478",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25513",
								"data-name": "Path 25513",
								d: "M408.324,342.869H574.286a.022.022,0,0,1,.022.022h0v98.237a.022.022,0,0,1-.022.022H408.324a.022.022,0,0,1-.022-.022V342.891a.022.022,0,0,1,.022-.022",
								transform: "translate(-298.075 -250.307)",
								fill: "#c3dcfa",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25514",
								"data-name": "Path 25514",
								d: "M598.086,753.7h34.5v17.2h18.264a1.625,1.625,0,0,1,1.62,1.606v1.634H578.2v-1.634a1.625,1.625,0,0,1,1.62-1.606h18.264Z",
								transform: "translate(-422.108 -550.229)",
								fill: "#032478",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25515",
								"data-name": "Path 25515",
								d: "M710.3,723.332a2.019,2.019,0,1,1-2.019,2.019,2.019,2.019,0,0,1,2.019-2.019",
								transform: "translate(-517.072 -528.059)",
								fill: "#b1d2fc",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25516",
								"data-name": "Path 25516",
								d: "M309.053,731.507h35.9c2.491,0,4.528,2.974,4.528,6.608s-2.038,6.608-4.528,6.608h-35.9c-2.49,0-4.529-2.974-4.529-6.608s2.038-6.608,4.529-6.608",
								transform: "translate(-222.314 -534.027)",
								fill: "#899bfa",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25517",
								"data-name": "Path 25517",
								d: "M347.682,731.507h12.872c-2.491,0-4.529,2.973-4.529,6.608s2.038,6.608,4.529,6.608H347.682c-2.491,0-4.529-2.973-4.529-6.608s2.038-6.608,4.529-6.608",
								transform: "translate(-250.514 -534.027)",
								fill: "#667ee8",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25518",
								"data-name": "Path 25518",
								d: "M442.478,748.155h33.96a8.935,8.935,0,0,1,0-9.189h-33.96c-1.137,0-2.069,2.07-2.069,4.594s.932,4.594,2.07,4.594",
								transform: "translate(-321.514 -539.472)",
								fill: "#edeeee",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25519",
								"data-name": "Path 25519",
								d: "M475.165,743.738a9.292,9.292,0,0,1,1.269-4.772H442.472c-1.137,0-2.069,2.07-2.069,4.594,0,.059,0,.119,0,.178Z",
								transform: "translate(-321.51 -539.472)",
								fill: "#e0e0df",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25520",
								"data-name": "Path 25520",
								d: "M473.68,744.723H438.546c-1.637,0-3.368-3.013-3.368-6.647s1.731-6.568,3.368-6.568H473.68l-.015,1.98-35.005.034c-1.137,0-2.069,2.07-2.069,4.594s.932,4.595,2.069,4.595l35.005-.034Z",
								transform: "translate(-317.696 -534.027)",
								fill: "#667ee8",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25521",
								"data-name": "Path 25521",
								d: "M468.508,780.462H430.973c-2.6,0-4.735,2.974-4.735,6.608s2.131,6.608,4.735,6.608h37.535c2.6,0,4.735-2.974,4.735-6.608s-2.131-6.608-4.735-6.608",
								transform: "translate(-311.169 -569.766)",
								fill: "#3d7dda",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25522",
								"data-name": "Path 25522",
								d: "M506.029,780.462H492.57c2.6,0,4.735,2.974,4.735,6.608s-2.131,6.608-4.735,6.608h13.459c2.6,0,4.735-2.973,4.735-6.608s-2.131-6.608-4.735-6.608",
								transform: "translate(-359.594 -569.766)",
								fill: "#105dc4",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25523",
								"data-name": "Path 25523",
								d: "M354.241,797.11H318.734a8.6,8.6,0,0,0,0-9.188h35.507c1.188,0,2.164,2.07,2.164,4.594s-.975,4.594-2.164,4.594",
								transform: "translate(-232.687 -575.212)",
								fill: "#edeeee",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25524",
								"data-name": "Path 25524",
								d: "M320.061,792.694a8.981,8.981,0,0,0-1.327-4.772h35.507c1.188,0,2.164,2.07,2.164,4.594,0,.059,0,.119,0,.178Z",
								transform: "translate(-232.687 -575.212)",
								fill: "#e0e0df",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25525",
								"data-name": "Path 25525",
								d: "M314.626,793.679h36.736c1.712,0,3.521-3.013,3.521-6.647s-1.809-6.568-3.521-6.568H314.626l.016,1.98,36.6.034c1.188,0,2.163,2.07,2.163,4.594s-.975,4.595-2.163,4.595l-36.6-.034Z",
								transform: "translate(-229.688 -569.767)",
								fill: "#105dc4",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25526",
								"data-name": "Path 25526",
								d: "M424.369,795.391H420.3c-1.559.818-1.109,4.063-2.035,6.188l2.4-1.755,1.742,1.642c1.35-1.926.578-5.214,1.956-6.074",
								transform: "translate(-305.352 -580.664)",
								fill: "#71bdf8",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25527",
								"data-name": "Path 25527",
								d: "M462.155,746.943h4.064c1.559.818,1.109,4.062,2.035,6.188l-2.4-1.755-1.742,1.642c-1.35-1.926-.578-5.214-1.956-6.074",
								transform: "translate(-337.39 -545.296)",
								fill: "#667ee8",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25528",
								"data-name": "Path 25528",
								d: "M815.753,735a13.414,13.414,0,1,0-.138-18.97,13.414,13.414,0,0,0,.138,18.97m-2.128,2.16a16.446,16.446,0,1,0-.169-23.257,16.446,16.446,0,0,0,.169,23.257h0",
								transform: "translate(-590.397 -517.6)",
								fill: "#899bfa",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25529",
								"data-name": "Path 25529",
								d: "M930.111,785.984l.82-2.732,27.968,7.656a2.135,2.135,0,0,1,1.308,2.549,2.2,2.2,0,0,1-2.516,1.465Z",
								transform: "translate(-679.015 -571.803)",
								fill: "#667ee8",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25530",
								"data-name": "Path 25530",
								d: "M924.97,782.7l.9-3.016a.7.7,0,0,1,1.344.4l-.9,3.016a.7.7,0,0,1-1.344-.4",
								transform: "translate(-675.242 -568.844)",
								fill: "#667ee8",
								fillRule: "evenodd"
							})
						]
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Group_9979",
					"data-name": "Group 9979",
					transform: "translate(256.801 212.493)",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group_9978",
						"data-name": "Group 9978",
						clipPath: "url(#clip-path-2)",
						children: /* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_15128",
							"data-name": "Rectangle 15128",
							width: 18.097,
							height: 27.522,
							transform: "translate(-3.353 10.621) rotate(-73.866)",
							fill: "#032478"
						})
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Group_9981",
					"data-name": "Group 9981",
					transform: "translate(0 0.001)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group_9980",
						"data-name": "Group 9980",
						transform: "translate(0 0)",
						children: [
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25532",
								"data-name": "Path 25532",
								d: "M823.812,724.232a13.419,13.419,0,0,0-1.506,17.012l.027-.017.349.536a13.555,13.555,0,0,0,1.269,1.439,13.414,13.414,0,1,0-.138-18.97",
								transform: "translate(-598.594 -525.797)",
								fill: "#d8eefb",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25533",
								"data-name": "Path 25533",
								d: "M830.319,745.47a.956.956,0,0,1,1.434,1.265,8.059,8.059,0,0,0-1.293,7.716.958.958,0,0,1-1.778.713l-.009-.023a9.88,9.88,0,0,1-.442-5.1,9.293,9.293,0,0,1,2.088-4.571",
								transform: "translate(-604.527 -543.984)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25534",
								"data-name": "Path 25534",
								d: "M897.66,744.807a8.746,8.746,0,0,1,1.266,2.754.836.836,0,0,0,1.04.69.987.987,0,0,0,.761-1.15,9.631,9.631,0,0,0-2.011-3.984.965.965,0,0,0-1.559.339c-.27.587.205.91.5,1.35",
								transform: "translate(-654.898 -542.309)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_15129",
								"data-name": "Rectangle 15129",
								width: 34.503,
								height: 4.288,
								transform: "translate(175.978 203.471)",
								fill: "#32509f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_15130",
								"data-name": "Rectangle 15130",
								width: 113.13,
								height: 147.356,
								transform: "translate(136.665 43.487)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25535",
								"data-name": "Path 25535",
								d: "M800.316,313.542a11.1,11.1,0,1,0,3.251,7.848,11.1,11.1,0,0,0-3.251-7.848m-7.848-5.937a13.785,13.785,0,1,1-9.746,4.038,13.785,13.785,0,0,1,9.746-4.038",
								transform: "translate(-568.468 -224.564)",
								fill: "#b1d2fc"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25536",
								"data-name": "Path 25536",
								d: "M805.824,337.893l10.524-9.813a2.034,2.034,0,1,1,2.77,2.98l-12.074,11.252-.03.025a2.04,2.04,0,0,1-2.868-.19l-5.816-6.658a2.033,2.033,0,0,1,3.058-2.679Z",
								transform: "translate(-582.442 -239.113)",
								fill: "#3d7dda",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25537",
								"data-name": "Path 25537",
								d: "M800.317,433.245a11.1,11.1,0,1,0,3.251,7.848,11.1,11.1,0,0,0-3.251-7.848m-7.848-5.937a13.785,13.785,0,1,1-9.746,4.038,13.785,13.785,0,0,1,9.746-4.038",
								transform: "translate(-568.469 -311.951)",
								fill: "#b1d2fc"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25538",
								"data-name": "Path 25538",
								d: "M800.317,552.948a11.1,11.1,0,1,0,3.251,7.848,11.1,11.1,0,0,0-3.251-7.848m-7.848-5.937a13.785,13.785,0,1,1-9.746,4.038,13.785,13.785,0,0,1,9.746-4.038",
								transform: "translate(-568.469 -399.338)",
								fill: "#b1d2fc"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25539",
								"data-name": "Path 25539",
								d: "M551.332,321.014h17.282a1.8,1.8,0,1,1,0,3.6H551.332a1.8,1.8,0,0,1,0-3.6",
								transform: "translate(-401.178 -234.352)",
								fill: "#899bfa",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25540",
								"data-name": "Path 25540",
								d: "M551.332,349.26h53a1.8,1.8,0,1,1,0,3.6h-53a1.8,1.8,0,0,1,0-3.6",
								transform: "translate(-401.178 -254.973)",
								fill: "#b1d2fc",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25541",
								"data-name": "Path 25541",
								d: "M551.333,380.577h36.506a1.8,1.8,0,1,1,0,3.6H551.333a1.8,1.8,0,0,1,0-3.6",
								transform: "translate(-401.179 -277.835)",
								fill: "#b1d2fc",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25542",
								"data-name": "Path 25542",
								d: "M551.332,440.716h17.282a1.8,1.8,0,1,1,0,3.6H551.332a1.8,1.8,0,0,1,0-3.6",
								transform: "translate(-401.178 -321.739)",
								fill: "#899bfa",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25543",
								"data-name": "Path 25543",
								d: "M551.332,560.419h17.282a1.8,1.8,0,1,1,0,3.6H551.332a1.8,1.8,0,0,1,0-3.6",
								transform: "translate(-401.178 -409.127)",
								fill: "#899bfa",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25544",
								"data-name": "Path 25544",
								d: "M551.332,468.963h53a1.8,1.8,0,1,1,0,3.6h-53a1.8,1.8,0,0,1,0-3.6",
								transform: "translate(-401.178 -342.36)",
								fill: "#b1d2fc",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25545",
								"data-name": "Path 25545",
								d: "M551.332,588.666h53a1.8,1.8,0,1,1,0,3.6h-53a1.8,1.8,0,0,1,0-3.6",
								transform: "translate(-401.178 -429.748)",
								fill: "#b1d2fc",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25546",
								"data-name": "Path 25546",
								d: "M551.333,500.279h36.506a1.8,1.8,0,1,1,0,3.6H551.333a1.8,1.8,0,0,1,0-3.6",
								transform: "translate(-401.179 -365.222)",
								fill: "#b1d2fc",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25547",
								"data-name": "Path 25547",
								d: "M551.333,619.981h36.506a1.8,1.8,0,1,1,0,3.6H551.333a1.8,1.8,0,0,1,0-3.6",
								transform: "translate(-401.179 -452.609)",
								fill: "#b1d2fc",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_15131",
								"data-name": "Rectangle 15131",
								width: 113.13,
								height: 9.398,
								transform: "translate(136.665 34.089)",
								fill: "#7ba9e3"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25548",
								"data-name": "Path 25548",
								d: "M857.188,135.133a2.027,2.027,0,1,1-2.027,2.027,2.027,2.027,0,0,1,2.027-2.027",
								transform: "translate(-624.299 -98.652)",
								fill: "#fff",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25549",
								"data-name": "Path 25549",
								d: "M878.555,135.133a2.027,2.027,0,1,1-2.027,2.027,2.027,2.027,0,0,1,2.027-2.027",
								transform: "translate(-639.897 -98.652)",
								fill: "#fff",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25550",
								"data-name": "Path 25550",
								d: "M899.923,135.133a2.027,2.027,0,1,1-2.027,2.027,2.027,2.027,0,0,1,2.027-2.027",
								transform: "translate(-655.497 -98.652)",
								fill: "#fff",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25551",
								"data-name": "Path 25551",
								d: "M1049.007,443.724a11.29,11.29,0,0,0-.321,3.7,10.534,10.534,0,0,1-1.76,6.249c-1.179,1.905-.37,5.993.027,6.26a53.363,53.363,0,0,0,6.974,3.07c1.2.224,8.355-4.63,8.355-4.63l.943-5.723Z",
								transform: "translate(-763.844 -323.935)",
								fill: "#2a4589",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25552",
								"data-name": "Path 25552",
								d: "M1032.079,535.815l-4.562,37.732,2.324,35.639-.232.313c-.06.081-.119.16-.178.237-.143.189-.283.365-.425.531-.063.076-.127.149-.192.22a6.3,6.3,0,0,1-3.51,1.7,2.51,2.51,0,0,0-2.1,1.459.6.6,0,0,0-.043.108.654.654,0,0,0,.644.835l10.169-.318a.981.981,0,0,0,.952-.873.927.927,0,0,0,0-.207l-.679-4.439a.078.078,0,0,0,0-.018c.247-8.666,2.207-21.364.6-31.486,0,0,9.6-18.988,9.566-19.449s-12.332-21.988-12.332-21.988",
								transform: "translate(-746.924 -391.165)",
								fill: "#ffae73"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25553",
								"data-name": "Path 25553",
								d: "M1075.171,659.776c.442,3.814-2.219,6.077-1.777,9.891.005,9.549,6.7,20.552,8.96,30.194.075.319-.495,3.352-.43,3.669,1.005,1.075,3.869,2.592,4.176-2.365-1.281-8.326-2.874-21.781-6.172-31.91l2.082-10.1Z",
								transform: "translate(-783.58 -481.208)",
								fill: "#ffae73"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25554",
								"data-name": "Path 25554",
								d: "M1026.255,560.015c-2.2,7.3-1.049,21.318.092,33.314,8.259,2.12,20.412,1.546,23.448-1.019-2.025-15.644-3.057-30.676-6.293-33.444-6.819-15.936-16.248-2.9-17.247,1.151",
								transform: "translate(-748.293 -402.358)",
								fill: "#2a4589",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25555",
								"data-name": "Path 25555",
								d: "M977.177,491.62s2.953,6.58.737,11.836c-.045.106-11.467,1.121-17.906.436-3.641-.387-5.172-1.625-3.428-3.119,1.8-1.544,15.434-.255,16.364-2.426,2.657-6.2,1.908-9.976,6.6-13.091.534-.344-.8,4.013-2.362,6.363",
								transform: "translate(-697.812 -354.242)",
								fill: "#899bfa",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25556",
								"data-name": "Path 25556",
								d: "M1051.6,483.156c1.942,7.925-5.836,8.919-4.075,24.918-5.827.81-13.284,1.088-18.295-.146.8-5.885.137-11.893-.1-15.107a16.2,16.2,0,0,1,2.738-10.679c1.714-2.654,16.443-3.88,19.726,1.015",
								transform: "translate(-751.268 -350.285)",
								fill: "#899bfa",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25557",
								"data-name": "Path 25557",
								d: "M1056.434,438.382l-.03,1.956-.284.243c-1.111,1.2.1,3.645,1.373,3.566,3.21.148,5.666-2.492,4.7-3.917l-.42-.466-.1-2.768c.166-.01,1.368-.7,1.728-.81a1.856,1.856,0,0,0,.916-1.534c.033-.73-1.094-.49-1.094-.49,1.36-1.874,2.9-3.406.891-5.083s-6.622-2.646-6.622-2.646l-2.776-.953a8.692,8.692,0,0,1-.466,5c-1,2.837-.184,6.7,2.19,7.9",
								transform: "translate(-769.331 -310.618)",
								fill: "#ffae73",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25558",
								"data-name": "Path 25558",
								d: "M1067.331,469.575s-1.56,2.7-2.848,2.943-.63.066-1.11.01l.03-1.956c.888.14,1.757.067,3.928-1",
								transform: "translate(-776.301 -342.807)",
								fill: "#e98385",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25559",
								"data-name": "Path 25559",
								d: "M1057.847,426.522s-4.113.071-5.6-1.21c-2.57-2.217-1.1-8.755,6.865-6.419,6.334,1.86,3.833,9.4,11.977,12.254,4.319,1.514,6,5.931,2.839,11.6-.015.01-.135-2.117-1.826-2.327a5.055,5.055,0,0,1-1.179,6.452c.534-5.375-2.3-9.577-10.459-11.33-2.947-2.147,1.871-8.359-2.617-9.017",
								transform: "translate(-767.334 -305.445)",
								fill: "#2a4589",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25560",
								"data-name": "Path 25560",
								d: "M1023.182,814.545s-3.541.98-3.382,2.072c.321,2.2,12.475.749,12.54.668a4.879,4.879,0,0,0-.1-3.765c-.432-.552-5.187,2.4-9.06,1.026",
								transform: "translate(-744.487 -593.848)",
								fill: "#2a4589",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25561",
								"data-name": "Path 25561",
								d: "M1100.974,818.3c.077,1.415,5.189,1.009,5.959.584,1.144-.631-.25-5.083-.681-4.588,0,0-1.333,2.1-2.909,1.674s-1.024-.891-1.293-.361c-.5.995-1.146,1.384-1.075,2.689",
								transform: "translate(-803.747 -594.44)",
								fill: "#2a4589",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25562",
								"data-name": "Path 25562",
								d: "M842.15,463.252l-.654,1.227,5.281,3.659,1.557-2.92Z",
								transform: "translate(-614.323 -338.191)",
								fill: "#3d7dda",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25563",
								"data-name": "Path 25563",
								d: "M874.494,473.356l-15.488-4.309a4.78,4.78,0,0,0-1.477,2.77L870,481.779l3.742-5.282Z",
								transform: "translate(-626.027 -342.422)",
								fill: "#ffae73",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25564",
								"data-name": "Path 25564",
								d: "M902.41,493.2l66.708,35.558,4.489-8.423L906.9,484.78c-.864-.461-2.57,1.051-3.81,3.376s-1.544,4.585-.679,5.045",
								transform: "translate(-658.433 -353.847)",
								fill: "#3d7dda",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25565",
								"data-name": "Path 25565",
								d: "M1150.19,619.874c-1.24,2.326-1.544,4.584-.679,5.045s2.57-1.051,3.81-3.376,1.544-4.584.679-5.045-2.57,1.051-3.81,3.376",
								transform: "translate(-838.826 -450.005)",
								fill: "#0e57bf",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25566",
								"data-name": "Path 25566",
								d: "M1082.526,487.307c7.231,2.242,9.724,15.523,8.693,19.941-.877,3.587-11.874,8.758-14.978,7.786-1.5-.469-.807-2.358-.8-2.92,3.038-1.7,9.229-5.759,9.331-6.64a16.683,16.683,0,0,0-2.218-8.222c-1.8-2.646-4.141-10.209-.027-9.945",
								transform: "translate(-784.99 -355.747)",
								fill: "#899bfa",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25567",
								"data-name": "Path 25567",
								d: "M1062.956,580.327l-1.081.5c-.395.067-4.772.455-4.016,1.19.132.128.207.128.407.112.4-.033.93-.184.916-.15-.262.655-1.461,1.3-1.488,1.355-.185.409,2.347,1.042,2.673.958,2.592-.669.819-.657,3.808-1.344,1.663-.383-.607-2.434-1.217-2.624",
								transform: "translate(-772.147 -423.66)",
								fill: "#ffae73",
								fillRule: "evenodd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_25568",
								"data-name": "Path 25568",
								d: "M958.439,544.681c.216-.226.2-1.04.452-1.371.378-.492.254-.434.27-.575.025-.218-2.208-2.6-4.152-1.172-.026.081-1.163-.312-1.221-.251-.278.291.257,1.53.43,2.027.336,1.487,3.325,1.544,4.22,1.342",
								transform: "translate(-696.242 -395.031)",
								fill: "#ffae73",
								fillRule: "evenodd"
							})
						]
					})
				})
			]
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_25569",
			"data-name": "Path 25569",
			d: "M-37.574-4.719H-40.3l1.367-3.68Zm.8,2.078L-35.816,0h2.563L-37.66-11.2h-2.555L-44.621,0h2.563l.961-2.641Zm9.922-8.8A5.97,5.97,0,0,0-31.18-9.727,5.542,5.542,0,0,0-32.941-5.6,5.554,5.554,0,0,0-31.18-1.473,5.962,5.962,0,0,0-26.855.242,5.916,5.916,0,0,0-25.164,0a6.136,6.136,0,0,0,1.32-.535,6.034,6.034,0,0,0,.945-.68,6.527,6.527,0,0,0,.57-.539A2.9,2.9,0,0,0-22.137-2l-1.445-1.523-.125.164a2.453,2.453,0,0,1-.406.406,5.974,5.974,0,0,1-.648.465,3.812,3.812,0,0,1-.926.4,4.034,4.034,0,0,1-1.168.168A3.563,3.563,0,0,1-29.48-2.977,3.563,3.563,0,0,1-30.535-5.6,3.563,3.563,0,0,1-29.48-8.227a3.563,3.563,0,0,1,2.625-1.055,3.629,3.629,0,0,1,1.117.176,4.09,4.09,0,0,1,.883.383,3.7,3.7,0,0,1,.621.48,3.624,3.624,0,0,1,.367.387l.129.176L-22.215-9.2l-.18-.234a3.707,3.707,0,0,0-.566-.555,9.1,9.1,0,0,0-.906-.656,5.011,5.011,0,0,0-1.309-.559A6.017,6.017,0,0,0-26.855-11.437Zm5.516.234v2.164h3.2V0h2.4V-9.039h3.2V-11.2ZM-10.785,0h2.406V-11.2h-2.406Zm8.313,0H.09L4.254-11.2H1.691l-2.883,8.32L-4.066-11.2H-6.629ZM6,0H8.41V-11.2H6ZM10.16-11.2v2.164h3.2V0h2.4V-9.039h3.2V-11.2ZM20.715,0h2.406V-11.2H20.715Zm7.68-2.156V-4.641h4.555V-6.8H28.395V-9.039H34.23V-11.2H25.988V0h8.406V-2.156ZM41.5-3.281a1.284,1.284,0,0,1-.488,1.031,2.059,2.059,0,0,1-1.355.406,3.235,3.235,0,0,1-1.437-.336,3.764,3.764,0,0,1-.887-.535q-.2-.2-.309-.324L35.582-1.6l.18.2a3.287,3.287,0,0,0,.516.461,7.205,7.205,0,0,0,.832.539,5.13,5.13,0,0,0,1.2.457,5.939,5.939,0,0,0,1.512.191,4.579,4.579,0,0,0,3.113-.984,3.214,3.214,0,0,0,1.129-2.539A2.838,2.838,0,0,0,43.5-5.1a3.217,3.217,0,0,0-1.387-1.031q-.816-.313-1.625-.547a5.825,5.825,0,0,1-1.375-.574,1.021,1.021,0,0,1-.566-.9,1.076,1.076,0,0,1,.418-.852,1.66,1.66,0,0,1,1.105-.352,2.482,2.482,0,0,1,1.109.266,3.212,3.212,0,0,1,.707.426q.168.16.262.27l1.438-1.523-.141-.156A2.358,2.358,0,0,0,43-10.465a5.944,5.944,0,0,0-.719-.437,4.8,4.8,0,0,0-1.051-.375,5.456,5.456,0,0,0-1.328-.16,4.124,4.124,0,0,0-2.832.961,2.986,2.986,0,0,0-1.09,2.32,2.838,2.838,0,0,0,.57,1.82A3.225,3.225,0,0,0,37.93-5.3q.809.313,1.625.543a5.594,5.594,0,0,1,1.383.574A1.03,1.03,0,0,1,41.5-3.281Z",
			transform: "translate(499 494)",
			fill: "#032578"
		})]
	})]
});
export default SvgEmptyList;
